import { ICompanyDto } from "./types-ensure";

export const clearVatNo = (countryCode: ICompanyDto["countryCode"], vatNo: ICompanyDto["vatNo"]) => {
  if (countryCode && vatNo) {
    const ex = `^(\\s*?${countryCode}\\s?)*`;
    const rgx = new RegExp(ex, "gm");

    return vatNo.replace(rgx, "").trim();
  }

  return "";
};

export const serializeCompanyDto = (values: ICompanyDto) => {
  return {
    ...values,
    orgNo: values.orgNo === "" ? null : values.orgNo,
    vatNo: values.vatNo === "" ? null : clearVatNo(values.countryCode, values.vatNo),
  };
};
